export enum OrderSideEnum {
	BUY = 'buy',
	SELL = 'sell',
	SELL_SHORT = 'sell_short',
}
